import React, { useState } from "react";
import { Field, ErrorMessage } from "formik";
import TextError from "./TextError";
const DropDown = (props) => {
  const { label, name, options, hasError, handleBlur, ...rest } = props;
  const [focused, setFocused] = useState(false);

  return (
    <>
      <div
        className={
          hasError
            ? `form-group has-error star ${focused ? "item-focused" : ""}`
            : `form-group star ${focused ? "item-focused" : ""}`
        }
      >
        <label htmlFor={name}> {label}</label>
        <div className="input">
          <Field
            onFocus={() => setFocused(true)}
            onBlur={(e) => {
              setFocused(false);
              handleBlur(e);
            }}
            as="select"
            className="form-control"
            id={name}
            name={name}
            {...rest}
          >
            {options.map((option) => {
              return (
                <option key={option.value} value={option.value}>
                  {option.key}
                </option>
              );
            })}
          </Field>
        </div>
      </div>
      <ErrorMessage name={name} component={TextError} />
    </>
  );
};

export default DropDown;
